import { useState } from 'preact/hooks';
import { suggestEmailCorrection } from '@/email';

// MIRROR: ezAuth implements the same reveal behavior in staticsol at
// node_js/ezauth/src/form.ts (buildEmailTypoHint) — reveal on blur, hide on
// focus, never while typing. Keep the two in sync.
export function useEmailSuggestion(email: string): { suggestion: string | null; revealSuggestion: () => void; hideSuggestion: () => void } {
  // shown holds the email the suggestion was computed for; the returned
  // suggestion masks it the moment the field's value moves on (e.g. the visitor
  // clicked the hint and the rewrite landed), without a setState round trip.
  const [shown, setShown] = useState<{ email: string; suggestion: string } | null>(null);

  // Blur reveals immediately. Accepted trade-off (mirrors ezAuth): a blur caused
  // by clicking submit shifts the button and eats that first click — only
  // triggers for typo addresses, where the interception is the point.
  const revealSuggestion = () => {
    const next = suggestEmailCorrection(email);
    setShown(next ? { email, suggestion: next } : null);
  };
  const hideSuggestion = () => setShown(null);

  return { suggestion: shown && shown.email === email ? shown.suggestion : null, revealSuggestion, hideSuggestion };
}
